import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-modal-cards',
  templateUrl: './modal-cards.component.html',
  styleUrls: ['./modal-cards.component.scss']
})
export class ModalCardsComponent {
  @Input() cards;

  @Output() modalPaymentChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  isModalCardsShow: boolean = false;
  isDarkBackground: boolean = false;

  openModalRequisitesShow() {
    this.isModalCardsShow = true;
    this.isDarkBackground = true;
  }

  showPaymentModal() {
    this.modalPaymentChange.emit();
    this.isModalCardsShow = false;
    this.isDarkBackground = false;
  }

  closeModal() {
    this.isModalCardsShow = false;
    this.isDarkBackground = false;
  }
}
